import ProductService from '../services/product.service';
import {
  ProductProductType,
  Product,
  Company,
  ProductType,
} from './models/models';

const queryProps = {
  filters: {},
  sort: [],
  page: 1,
  limit: 30,
};

export default {
  namespaced: true,
  state: {
    productId: null,
    total: null,
    query: {},
  },
  mutations: {
    productId(state, productId) {
      state.productId = productId;
    },
    total(state, total) {
      state.total = total;
    },
    initQueries(state) {
      const types = ['product', 'service'];
      types.forEach((categoryType) => {
        state.query[categoryType] = {
          ...queryProps,
          categoryType,
        };
      });
    },
    queryProps(state, payload) {
      state.query[payload.categoryType] = Object
        .assign({}, state.query[payload.categoryType], payload.props);
      state.query = { ...state.query };
    },
  },
  actions: {
    init({ commit }) {
      commit('initQueries');
    },
    newProduct({ commit }) {
      Product.new()
        .then((product) => commit('productId', product.id));
    },
    async updateProductProps({ state }, props) {
      if (props.hasOwnProperty('types')) {
        ProductType.insert({ data: props.types });

        // Delete previous
        ProductProductType.delete((productType) => productType.product_id === state.productId)
          .then(() => {
            // Add again
            ProductProductType.insert({
              data: props.types.map((productType) => ({
                product_id: state.productId,
                product_type_id: productType.id,
              })),
            });
          });
      }
      if (props.hasOwnProperty('supplier_company')) {
        Company.insert({ data: props.supplier_company });
      }
      Product.update({
        where: state.productId,
        data: props,
      });
    },
    suggestProducts(store, params) {
      return ProductService.suggestProducts(params);
    },
    getProducts({ commit, state }, productType) {
      const productProps = state.query[productType];
      return ProductService.getProducts(productProps)
        .then((res) => {
          commit('total', res.total);
          Product.create({
            data: res.data,
            insertOrUpdate: ['companies', 'product_types'],
          });
        });
    },
    getProductPrice({ rootGetters }) {
      const params = {
        product_id: rootGetters['orderLines/orderLine'].product.id,
        user_id: rootGetters['orders/order'].user_id,
        order_id: rootGetters['orders/order'].id,
        quantity: rootGetters['orderLines/orderLine'].quantity,
      };

      return ProductService.getProductPrice(params);
    },
    getProduct({ commit }, id) {
      return ProductService.getProduct(id)
        .then((product) => {
          commit('productId', product.id);
          Product.create({
            data: [product],
            insert: ['categories', 'product_types'],
          });
        });
    },
    createProduct({ getters }) {
      return ProductService.createProduct(getters.product);
    },
    updateProduct({ getters, dispatch }) {
      return ProductService.updateProduct(getters.product)
        .then((res) => {
          if (res.hasOwnProperty('product_id')) {
            dispatch('getProduct', res.product_id);
          }
          return res;
        });
    },
    deleteProduct({ getters }) {
      return ProductService.deleteProduct(getters.product)
        .then((res) => {
          if (res.hasOwnProperty('product_id')) {
            Product.delete(res.product_id);
          }
          return res;
        });
    },
  },
  getters: {
    products() {
      return Product.query()
        .with(['types', 'supplier_company'])
        .all();
    },
    product(state) {
      if (!state.productId) {
        return null;
      }
      return Product.query()
        .with(['types', 'supplier_company'])
        .find(state.productId);
    },
  },
};
